import styled from 'styled-components'

export const Container = styled.fieldset`
  padding: 0;

  & & {
    padding-top: var(--space-200);
    padding-left: var(--space-900);
  }
`
